import {InjectionToken} from '@angular/core';

export const DIRECTUS_URL = new InjectionToken<string>('DIRECTUS_URL');
